module.exports = __webpack_public_path__ + "static/img/role.1113f2d.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/news2/role.png
// module id = KB8q
// module chunks = 7